import moment from "moment";
import { getConnectedUser } from "@/utils/localStorage";

export function validateCPF(cpf) {
  // Verificar se o CPF tem 11 dígitos
  if (cpf.length !== 11) {
    return false;
  }

  // Verificar se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cpf)) {
    return false;
  }

  // Calcular o primeiro dígito verificador
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let remainder = 11 - (sum % 11);
  let firstDigitCheck = remainder === 10 || remainder === 11 ? 0 : remainder;

  // Verificar o primeiro dígito verificador
  if (firstDigitCheck !== parseInt(cpf.charAt(9))) {
    return false;
  }

  // Calcular o segundo dígito verificador
  sum = 0;

  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }

  remainder = 11 - (sum % 11);

  let secondDigitCheck = remainder === 10 || remainder === 11 ? 0 : remainder;

  // Verificar o segundo dígito verificador
  // CPF válido ou não.
  return secondDigitCheck === Number(cpf.charAt(10));
}

export function validateCNS(cns) {
  cns = cns.toString();

  // Verificar se o CNS tem 15 dígitos
  if (cns.length !== 15) {
    return false;
  }

  // Verificar se o primeiro dígito é válido
  if (cns.charAt(0) < "0" || cns.charAt(0) > "9") {
    return false;
  }

  // Calcular a soma ponderada dos dígitos
  let sum = 0;
  let multiplier = 15;

  for (let i = 0; i < cns.length; i++) {
    sum += parseInt(cns.charAt(i) * multiplier);
    multiplier--;
  }

  const remainder = sum % 10;

  const checkDigit = 10 - remainder;
  return checkDigit > 0 && checkDigit < 10;
}

export function areObjectsEqual(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
}

export function hasInvalidValues(obj) {
  for (const key in obj) {
    if (
      obj[key] === "" ||
      obj[key] === null ||
      obj[key] === undefined ||
      (Array.isArray(obj[key]) && obj[key].length === 0)
    ) {
      return true;
    }
  }
  return false;
}

export function checkArrayIsValid(array) {
  const check = Array.isArray(array);

  if (check) {
    return array.length > 0;
  }

  return false;
}

export function checkStringIsValid(string) {
  const check = string !== "" && string !== null && string !== undefined;
  return check;
}

export function removeEmptyAndFalseProperties(obj) {
  return Object.keys(obj)
    .filter((key) => {
      const value = obj[key];
      // Verifica se o valor é um objeto e se está vazio
      if (
        value &&
        typeof value === "object" &&
        Object.keys(value).length === 0
      ) {
        return false;
      }
      // Exclui valores null, undefined, "", e false
      return (
        value !== null && value !== undefined && value !== "" && value !== false
      );
    })
    .reduce((newObj, key) => {
      newObj[key] = obj[key];
      return newObj;
    }, {});
}

export function countNonEmptyKeys(obj) {
  return Object.values(obj).filter(
    (value) =>
      value !== "" &&
      value !== null &&
      value !== undefined &&
      value.length !== 0
  ).length;
}

export function hasObjectWithName(array, nameKey, nameValue) {
  return array.some((obj) => obj[nameKey] === nameValue);
}

export function checkTypeOfFirstCharacter(str) {
  return /\d/.test(str.charAt(0)) ? "number" : "string";
}

export function checkIfEndDateIsSameOfBefore(start_date, end_date) {
  const startDate = moment(start_date, "DD/MM/YYYY");
  const endDate = moment(end_date, "DD/MM/YYYY");

  if (startDate.isValid() && endDate.isValid()) {
    return startDate.isSameOrBefore(endDate, "day");
  }

  return false;
}

export function checkIsValidCoordinates(value) {
  const num = parseFloat(value);
  return !isNaN(num) && num >= -180 && num <= 180;
}

export function checkProfileForBindUnity() {
  const connectedUser = getConnectedUser();
  const profile = connectedUser.profile.toUpperCase();
  const typeUnity = connectedUser.unity_type.toUpperCase();

  return (
    (profile === "ADMINISTRADOR" ||
      profile === "AVALIADOR" ||
      profile === "AVALIADOR/REGULADOR" ||
      profile === "REGULADOR/CER") &&
    typeUnity === "ADMINISTRATIVA"
  );
}
